// src/router/index.js — Stag Fondation
// SEO dynamique sans dépendance : manipulation DOM directe via seoManager

import AdminFormationRegistrations from '@/components/admins/AdminFormationRegistrations.vue'
import Adminprojects               from '@/components/admins/adminprojects.vue'
import AdminTeamMembers            from '@/components/admins/AdminTeamMembers.vue'
import AdminEvent                  from '@/components/admins/adminEvent.vue'
import Articles                    from '@/components/admins/articles.vue'
import AdminAssociations           from '@/components/admins/associations.vue'
import AdminContact                from '@/components/admins/contact.vue'
import Dashboard                   from '@/components/admins/dashboard.vue'
import Donations                   from '@/components/admins/donations.vue'
import adminFormations             from '@/components/admins/formations.vue'
import Settings                    from '@/components/admins/settings.vue'
import About                       from '@/components/pages/acceuil/about.vue'
import AcceuilComponent            from '@/components/pages/acceuil/AcceuilComponent.vue'
import Associations                from '@/components/pages/acceuil/associations.vue'
import Blog                        from '@/components/pages/acceuil/blog.vue'
import Contact                     from '@/components/pages/acceuil/contact.vue'
import Donnate                     from '@/components/pages/acceuil/donnate.vue'
import Formations                  from '@/components/pages/acceuil/formations.vue'
import Projects                    from '@/components/pages/acceuil/projects.vue'
import Singleassociation           from '@/components/pages/acceuil/singleassociation.vue'
import Events                      from '@/components/pages/acceuil/event.vue'
import SingleEvent                 from '@/components/pages/acceuil/singleEvent.vue'
import Singleformation             from '@/components/pages/acceuil/singleformation.vue'
import Singlenews                  from '@/components/pages/acceuil/singlenews.vue'
import Singleproject               from '@/components/pages/acceuil/singleproject.vue'
import TeamPage                    from '@/components/pages/acceuil/TeamPage.vue'
import AdminloginComponent         from '@/components/pages/login/AdminloginComponent.vue'
import AdminLayout                 from '@/components/pages/navbar/adminLayout.vue'
import Layout                      from '@/components/pages/navbar/layout.vue'
import AdminReviews                 from '@/components/admins/Adminreviews.vue'
import { createRouter, createWebHistory } from 'vue-router'

import store      from '@/store'
import seoManager from '@/utils/seoManager'

// ─── Guard auth admin ─────────────────────────────────────────────────────────
function isAuthenticated() {
  return !!(store.state.token || localStorage.getItem('token'))
}
function isAdmin() {
  const user = store.state.user || JSON.parse(localStorage.getItem('user') || '{}')
  return user?.role === 1
}

// ─── Mise à jour SEO selon le type de route ───────────────────────────────────
async function updateSEO(to) {
  const seoType = to.meta?.seoType

  // Pages admin : noindex + nettoyage des schemas
  if (!seoType) {
    seoManager._setMeta('robots', 'noindex, nofollow')
    seoManager.clearSchemas()
    return
  }

  seoManager.clearSchemas()

  switch (seoType) {

    // ── Pages statiques ──────────────────────────────────────────────
    case 'home': {
      seoManager.setMetaTags(seoManager.generateHomeSEO())
      seoManager.injectOrganizationSchema()
      seoManager.injectWebSiteSchema()
      break
    }
    case 'a-propos': {
      seoManager.setMetaTags(seoManager.generateAboutSEO())
      seoManager.injectOrganizationSchema()
      break
    }
    case 'contact': {
      seoManager.setMetaTags(seoManager.generateContactSEO())
      break
    }
    case 'team': {
      seoManager.setMetaTags(seoManager.generateTeamSEO())
      break
    }
    case 'faire-un-don': {
      seoManager.setMetaTags(seoManager.generateDonationSEO())
      seoManager.injectOrganizationSchema()
      break
    }
    case 'actualites': {
      seoManager.setMetaTags(seoManager.generateBlogSEO())
      seoManager.injectBreadcrumbSchema([
        { name: 'Accueil',     url: '/' },
        { name: 'Actualités', url: '/actualites' }
      ])
      break
    }
    case 'projets': {
      seoManager.setMetaTags(seoManager.generateProjectsSEO())
      seoManager.injectBreadcrumbSchema([
        { name: 'Accueil', url: '/' },
        { name: 'Projets', url: '/projets' }
      ])
      break
    }
    case 'formations': {
      seoManager.setMetaTags(seoManager.generateFormationsSEO())
      seoManager.injectBreadcrumbSchema([
        { name: 'Accueil',     url: '/' },
        { name: 'Formations', url: '/formations' }
      ])
      break
    }
    case 'associations': {
      seoManager.setMetaTags(seoManager.generateAssociationsSEO())
      seoManager.injectBreadcrumbSchema([
        { name: 'Accueil',       url: '/' },
        { name: 'Associations', url: '/associations' }
      ])
      break
    }
    case 'evenements': {
      seoManager.setMetaTags(seoManager.generateEventsSEO())
      seoManager.injectBreadcrumbSchema([
        { name: 'Accueil',      url: '/' },
        { name: 'Événements', url: '/evenements' }
      ])
      break
    }

    // ── Pages dynamiques ─────────────────────────────────────────────

    case 'singlenews': {
      // Fallback immédiat
      seoManager.setMetaTags(seoManager.generateBlogSEO())

      let article = store.state.currentArticle
      if (article?.slug !== to.params.slug) article = null

      if (!article) {
        try {
          await store.dispatch('fetchArticleBySlug', to.params.slug)
          article = store.state.currentArticle
        } catch (e) { /* garder le fallback */ }
      }

      if (article) {
        const seoData = seoManager.generateArticleSEO(article)
        seoManager.setMetaTags(seoData)
        seoManager.injectArticleSchema(article, seoData.image)
        seoManager.injectBreadcrumbSchema([
          { name: 'Accueil',     url: '/' },
          { name: 'Actualités', url: '/actualites' },
          { name: article.title, url: `/actualite/${article.slug}` }
        ])
      }
      break
    }

    case 'single-formation': {
      seoManager.setMetaTags(seoManager.generateFormationsSEO())

      let formation = store.state.currentFormation
      if (formation?.slug !== to.params.slug) formation = null

      if (!formation) {
        try {
          await store.dispatch('fetchFormationBySlug', to.params.slug)
          formation = store.state.currentFormation
        } catch (e) {}
      }

      if (formation) {
        const seoData = seoManager.generateFormationSEO(formation)
        seoManager.setMetaTags(seoData)
        seoManager.injectFormationSchema(formation, seoData.image)
        seoManager.injectBreadcrumbSchema([
          { name: 'Accueil',     url: '/' },
          { name: 'Formations', url: '/formations' },
          { name: formation.title, url: `/formation/${formation.slug}` }
        ])
      }
      break
    }

    case 'projet': {
      seoManager.setMetaTags(seoManager.generateProjectsSEO())

      let project = store.state.currentProject
      if (project?.slug !== to.params.slug) project = null

      if (!project) {
        try {
          await store.dispatch('fetchProjectBySlug', to.params.slug)
          project = store.state.currentProject
        } catch (e) {}
      }

      if (project) {
        const seoData = seoManager.generateProjectSEO(project)
        seoManager.setMetaTags(seoData)
        seoManager.injectProjectSchema(project, seoData.image)
        seoManager.injectBreadcrumbSchema([
          { name: 'Accueil', url: '/' },
          { name: 'Projets', url: '/projets' },
          { name: project.title, url: `/projet/${project.slug}` }
        ])
      }
      break
    }

    case 'single-association': {
      seoManager.setMetaTags(seoManager.generateAssociationsSEO())

      let association = store.state.currentAssociation
      if (association?.slug !== to.params.slug) association = null

      if (!association) {
        try {
          await store.dispatch('fetchAssociationBySlug', to.params.slug)
          association = store.state.currentAssociation
        } catch (e) {}
      }

      if (association) {
        const seoData = seoManager.generateAssociationSEO(association)
        seoManager.setMetaTags(seoData)
        seoManager.injectAssociationSchema(association, seoData.image)
        seoManager.injectBreadcrumbSchema([
          { name: 'Accueil',       url: '/' },
          { name: 'Associations', url: '/associations' },
          { name: association.name, url: `/association/${association.slug}` }
        ])
      }
      break
    }

    // ── NOUVEAU : événement unique ───────────────────────────────────
    case 'single-event': {
      // 1. Fallback pendant le chargement
      seoManager.setMetaTags(seoManager.generateEventsSEO())

      let event = store.state.currentEvent
      if (event?.slug !== to.params.slug) event = null

      // 2. Fetch si nécessaire
      if (!event) {
        try {
          await store.dispatch('fetchEventBySlug', to.params.slug)
          event = store.state.currentEvent
        } catch (e) { /* garder le fallback */ }
      }

      if (event) {
        const seoData = seoManager.generateEventSEO(event)
        seoManager.setMetaTags(seoData)
        seoManager.injectEventSchema(event, seoData.image)
        seoManager.injectBreadcrumbSchema([
          { name: 'Accueil',      url: '/' },
          { name: 'Événements', url: '/evenements' },
          { name: event.title,    url: `/evenement/${event.slug}` }
        ])
      }
      break
    }

    default:
      seoManager.setMetaTags(seoManager.generateHomeSEO())
  }
}

// ─── Routes ───────────────────────────────────────────────────────────────────
const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, behavior: 'smooth' }
  },
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        { path: '',                  name: 'Acceuil',           components: { two: AcceuilComponent },  meta: { seoType: 'home' } },
        { path: 'a-propos',          name: 'a-propos',          components: { two: About },             meta: { seoType: 'a-propos' } },
        { path: 'associations',      name: 'associations',      components: { two: Associations },      meta: { seoType: 'associations' } },
        { path: 'association/:slug', name: 'single-association',components: { two: Singleassociation }, meta: { seoType: 'single-association' } },
        { path: 'contact',           name: 'contact',           components: { two: Contact },           meta: { seoType: 'contact' } },
        { path: 'team',              name: 'team',              components: { two: TeamPage },          meta: { seoType: 'team' } },
        { path: 'faire-un-don',      name: 'faire-un-don',      components: { two: Donnate },           meta: { seoType: 'faire-un-don' } },
        { path: 'actualites',        name: 'actualites',        components: { two: Blog },              meta: { seoType: 'actualites' } },
        { path: 'actualite/:slug',   name: 'singlenews',        components: { two: Singlenews },        meta: { seoType: 'singlenews' } },
        { path: 'projets',           name: 'projets',           components: { two: Projects },          meta: { seoType: 'projets' } },
        { path: 'projet/:slug',      name: 'projet',            components: { two: Singleproject },     meta: { seoType: 'projet' } },
        { path: 'formations',        name: 'formations',        components: { two: Formations },        meta: { seoType: 'formations' } },
        { path: 'formation/:slug',   name: 'single-formation',  components: { two: Singleformation },   meta: { seoType: 'single-formation' } },
        // ── Événements ──────────────────────────────────────────────
        { path: 'evenements',        name: 'evenements',        components: { two: Events },            meta: { seoType: 'evenements' } },
        { path: 'evenement/:slug',   name: 'singleevent',       components: { two: SingleEvent },       meta: { seoType: 'single-event' } },
      ]
    },

    // Admin — noindex, protection auth
    {
      path: '/systeme/admin/login',
      name: 'admin-login',
      component: AdminloginComponent,
      meta: { guestOnly: true }
    },
    {
      path: '/systeme/admin/',
      name: 'systeme-admin',
      component: AdminLayout,
      meta: { requiresAuth: true, requiresAdmin: true },
      children: [
        { path: 'evenements',                   name: 'admin.evenements',        components: { tree: AdminEvent } },
        { path: 'articles',                     name: 'admin-articles',          components: { tree: Articles } },
        { path: 'contacts',                     name: 'admin-contacts',          components: { tree: AdminContact } },
        { path: 'associations',                 name: 'admin-associations',      components: { tree: AdminAssociations } },
        { path: 'dashboard',                    name: 'admin-dashboard',         components: { tree: Dashboard } },
        { path: 'dons',                         name: 'admin-dons',              components: { tree: Donations } },
        { path: 'formations',                   name: 'admin-formations',        components: { tree: adminFormations } },
        { path: 'teams',                        name: 'admin-admin-teams',       components: { tree: AdminTeamMembers } },
        { path: 'avis', name: 'admin-avis', components: { tree: AdminReviews } },
        { path: 'formations/:id/registrations', name: 'single-admin-formations', components: { tree: AdminFormationRegistrations } },
        { path: 'projets',                      name: 'admin-projects',          components: { tree: Adminprojects } },
        { path: 'configurations',               name: 'admin-configurations',    components: { tree: Settings } },

      ]
    }
  ]
})

// ─── Guard principal ──────────────────────────────────────────────────────────
router.beforeEach(async (to, from, next) => {
  const requiresAuth  = to.matched.some(r => r.meta?.requiresAuth)
  const requiresAdmin = to.matched.some(r => r.meta?.requiresAdmin)
  const guestOnly     = to.matched.some(r => r.meta?.guestOnly)

  const auth  = isAuthenticated()
  const admin = isAdmin()

  if (guestOnly && auth && admin) {
    next({ name: 'admin-dashboard' })
    return
  }
  if (requiresAuth && !auth) {
    next({ name: 'admin-login' })
    return
  }
  if (requiresAdmin && auth && !admin) {
    next({ path: '/' })
    return
  }

  await updateSEO(to)
  next()
})

export default router